import React from 'react';
import DOMPurify from 'dompurify';
import ClearRefinements from '../ClearRefinements';
export default function CurrentRefinements({ currentRefinements, currentRefinementsSettings, additionalData, results, clearRefinements, }) {
    var _a;
    const { items, refine, createURL, } = currentRefinements;
    const { classNames, showLabel, showClearAll, clearRefinementsSettings, translations, } = currentRefinementsSettings;
    const rootClassName = [
        (_a = classNames === null || classNames === void 0 ? void 0 : classNames.rootList) !== null && _a !== void 0 ? _a : 'tag-list-wrap',
        items.length === 0 ? 'tag-list-wrap--no-results' : '',
    ].filter(Boolean).join(' ');
    return (React.createElement("ul", { className: rootClassName },
        items.map((item) => {
            var _a, _b, _c;
            return (React.createElement("li", { key: item.label, className: (_a = classNames === null || classNames === void 0 ? void 0 : classNames.listItem) !== null && _a !== void 0 ? _a : 'tags' },
                (showLabel !== null && showLabel !== void 0 ? showLabel : true) && (React.createElement("span", { className: (_b = classNames === null || classNames === void 0 ? void 0 : classNames.label) !== null && _b !== void 0 ? _b : 'tag-label' }, translations ? (translations[item.label] || item.label) : item.label)),
                React.createElement("ul", { className: (_c = classNames === null || classNames === void 0 ? void 0 : classNames.list) !== null && _c !== void 0 ? _c : 'tag-list' }, item.refinements.map((nested) => {
                    var _a;
                    return (React.createElement("li", { key: nested.label },
                        React.createElement("a", { className: (_a = classNames === null || classNames === void 0 ? void 0 : classNames.link) !== null && _a !== void 0 ? _a : 'tag', href: createURL(nested), onClick: (event) => {
                                event.preventDefault();
                                refine(nested);
                            }, 
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML: {
                                __html: DOMPurify.sanitize(nested.label),
                            }, "aria-label": nested.label })));
                }))));
        }),
        (showClearAll !== null && showClearAll !== void 0 ? showClearAll : true) && (React.createElement("li", null,
            React.createElement(ClearRefinements, { additionalData: additionalData, clearRefinements: clearRefinements, clearRefinementsSettings: clearRefinementsSettings || {}, results: results })))));
}
